import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { SocketService } from 'src/app/services/socket.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-transaction-charts',
  templateUrl: './transaction-charts.component.html',
  styleUrls: ['./transaction-charts.component.css']
})
export class TransactionChartsComponent implements OnInit {

  chartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#000000' : '#ffffff';
  piechartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#2740a6' : '#2740a6';
  transactionAccounts: any[];
  transactionChartDatas: any;
  transactionElement: any;
  transactionUsersCount: any;
  transactionAccounts1: any[];
  transactionAccounts2: any[];
  chartName: any;
  constructor(private conn: ConnectionService, private router: Router,
    private alert: ToastrService, private activatedRoute: ActivatedRoute, private socketService: SocketService,private spinner : NgxSpinnerService) { }

  ngOnInit() {
    this.chartName = this.activatedRoute.snapshot.params['name'];
    this.yearlyTransaction('yearly')
    this.monthlyTransaction('monthly')
    this.dailyTransaction('daily')
  }

  socketCharts(): any {
    this.socketService.latestBlocks().subscribe((res: any) => {
      if (res == 'latestblocks') {
       
      }
    });
  }

  yearlyTransaction(type: any) {
    // this.spinner.show()
    this.transactionAccounts = []
    this.conn.postUrl('users/transactionChart', { type: type }).subscribe((transactionChartRes: any) => {
      // this.spinner.hide()
      this.transactionChartDatas = transactionChartRes.data
      let categoriesData = []
      for (let index = 0; index < this.transactionChartDatas.length; index++) {
        this.transactionElement = this.transactionChartDatas[index];
        this.transactionUsersCount = this.transactionElement.usersCount
        this.transactionAccounts.push(this.transactionUsersCount)
        if (type == 'yearly') {
          categoriesData.push(this.transactionChartDatas[index].year)
        }
        if (index == this.transactionChartDatas.length - 1) {
          this.yearlytransactionchart(categoriesData);
        }
      }
    })
  }

  monthlyTransaction(type: any) {
    this.transactionAccounts1 = []
    this.conn.postUrl('users/transactionChart', { type: type }).subscribe((transactionChartRes: any) => {
      this.transactionChartDatas = transactionChartRes.data
      let categoriesData = []
      for (let index = 0; index < this.transactionChartDatas.length; index++) {
        this.transactionElement = this.transactionChartDatas[index];
        this.transactionUsersCount = this.transactionElement.usersCount
        this.transactionAccounts1.push(this.transactionUsersCount)
        categoriesData.push(this.transactionChartDatas[index].monthInName)
        if (index == this.transactionChartDatas.length - 1) {
          this.monthlytransactionchart(categoriesData);
        }
      }
    })
  }

  dailyTransaction(type: any) {
    this.transactionAccounts2 = []
    this.conn.postUrl('users/transactionChart', { type: type }).subscribe((transactionChartRes: any) => {
      this.transactionChartDatas = transactionChartRes.data
      let categoriesData = []
      for (let index = 0; index < this.transactionChartDatas.length; index++) {
        this.transactionElement = this.transactionChartDatas[index];
        this.transactionUsersCount = this.transactionElement.usersCount
        this.transactionAccounts2.push(this.transactionUsersCount)
        categoriesData.push(this.transactionChartDatas[index].date)
        if (index == this.transactionChartDatas.length - 1) {
          this.dailytransactionchart(categoriesData);
        }
      }
    })
  }


  yearlytransactionchart(category: any) {
    Highcharts.chart('yearly_Transaction_chart', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y}</b></span>`,
        style :{
          backgroundColor:'#ffffff'
        }
      },
      series: [{
        name: 'Total Transactions',
        color: '#2740a6',
        data: this.transactionAccounts,
      }],
    } as any);
  }

  monthlytransactionchart(category: any) {
    Highcharts.chart('monthly_Transaction_chart', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y} </b></span>`,
        style :{
          backgroundColor:'#ffffff'
        }
      },
      series: [{
        name: 'Total Transactions',
        color: '#2740a6',
        data: this.transactionAccounts1,
      }],
    } as any);
  }

  dailytransactionchart(category: any) {
    Highcharts.chart('daily_Transaction_chart', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y} </b></span>`,
        style :{
          backgroundColor:'#ffffff'
        }
      },
      series: [{
        name: 'Total Transactions',
        color: '#2740a6',
        data: this.transactionAccounts2,
      }],
    } as any);
  }

}
